import PhotoDocumentRelabel from './PhotoDocumentRelabel';

export default PhotoDocumentRelabel;
